import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment, getHttpParamsFromObject } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import {
    PaymentProfilesListResponse,
    PaymentProfileStatus,
    PaymentProfileCreateRequest,
    PaymentProfile,
    PaymentProfileEditRequest
} from '../entities';
import { ProfilesPageParams } from '../state/profiles/profiles.model';

@Injectable({ providedIn: 'root' })
export class PaymentProfilesDataService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = '/rest/payment-profiles';

    getProfilesList(pageParams: ProfilesPageParams): Observable<PaymentProfilesListResponse> {
        const params = getHttpParamsFromObject(pageParams);

        return this.http.get<PaymentProfilesListResponse>(`${environment.apiUrl}${this.baseUrl}`, {
            params
        });
    }

    getProfileDetails(id: number): Observable<PaymentProfile> {
        return this.http.get<PaymentProfile>(`${environment.apiUrl}${this.baseUrl}/${id}`);
    }

    deleteProfile(id: number): Observable<void> {
        return this.http.post<void>(`${environment.apiUrl}${this.baseUrl}/${id}/change-status`, {
            status: PaymentProfileStatus.Deleted
        });
    }

    changeProfileStatus(id: number, status: PaymentProfileStatus): Observable<void> {
        return this.http.post<void>(`${environment.apiUrl}${this.baseUrl}/${id}/change-status`, {
            status
        });
    }

    createProfile(profile: PaymentProfileCreateRequest): Observable<PaymentProfile> {
        return this.http.post<PaymentProfile>(`${environment.apiUrl}${this.baseUrl}`, profile);
    }

    editProfile(profile: PaymentProfileEditRequest): Observable<PaymentProfile> {
        return this.http.put<PaymentProfile>(`${environment.apiUrl}${this.baseUrl}`, profile);
    }
}
